window.addEventListener('DOMContentLoaded', function() {
    var currentDay = new Date().getDay(); // Get the current day (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    var currentHour = new Date().getHours(); // Get the current hour

    // Check if it's within the allowed hours
    var isWithinHours = false;
    if (currentDay >= 1 && currentDay <= 6) { // Monday to Saturday
        isWithinHours = currentHour >= 10 && currentHour < 22;
    } else if (currentDay === 0) { // Sunday
        isWithinHours = currentHour >= 10 && currentHour < 21;
    }

    // Check if it's outside the allowed hours
    if (!isWithinHours) {
        // Display warning message
        alert("Sorry, The store is currently closed and unable to deliver at this time. If you place an order now, we will deliver the items to you the next day.");

        // Optional: You can hide the checkout button or any other action here
        // For example, hiding the checkout button:
        // var checkoutButton = document.querySelector('.checkout-button');
        // if (checkoutButton) {
        //     checkoutButton.style.display = 'none';
        // }
    }
});
